import React from 'react';
import moment from 'jalali-moment';
import { useResponsive } from '../../../hooks/useResponsive';

interface OrderCompletionInfoProps {
  form: any;
}

const UserUploadedPhoto: React.FC<OrderCompletionInfoProps> = ({ form }) => {
  const { isMobile } = useResponsive();

  if (!form?.orderServices?.filter(e => e.media || e.pinterest).length) {
    return null;
  }

  return (
    <section className="completion-info">
      {form?.orderServices?.map(e =>
        e.media? (
          <div className="bottom width100">
            <h6 className="dashBoardTitle">عکس آپلود شده برای {e.service.title}</h6>
            {e.media?.url && <img
              className={`orderFinalImage ${isMobile ? 'mobile-image' : ''}`}
              src={e.media?.url}
              alt="عکس آپلود شده"
              loading="lazy"
            />}
            {e.pinterest && <a href={e.pinterest} target='_blank'>لینک پینترست</a>}
          </div>
        )
      : null
      )}
    </section>

  );
};

export default UserUploadedPhoto;
